import Colors from '@/constants/Colors';
import MediaQueryBreakpoints from '@/constants/MediaQueryBreakpoints';
import { pxToVw } from '@/modules/styled/cssUnits';
import styled from 'styled-components';

const StyledThemeActivities = styled.div`
  display: flex;

  h3 {
    font-size: var(--font-size-h4);
    line-height: var(--line-height-h4);
  }

  .activity {
    display: flex;
    width: 100%;

    .activity-type-name {
      margin: 0;
    }

    .activity-type-icon {
      transition: all 0.3s;
      border: 2px solid white;
      outline: 3px solid transparent;
    }

    &.selected {
      .activity-type-icon {
        border-color: white;
        outline-color: ${Colors.primary};
      }

      h3.activity-type-name {
        color: ${Colors.primary};
      }
    }
  }

  @media only screen and (max-width: ${MediaQueryBreakpoints.md}) {
    .activity .activity-type-icon {
      width: 40px !important;
      height: 40px !important;
      .free-tag {
        right: -16px;
      }
      svg {
        transform: scale(2) !important;
      }
    }
  }
`;

export const StyledThemeActivitiesRow = styled(StyledThemeActivities)`
  flex-direction: row;
  flex-wrap: wrap;
  gap: 20px 5px;

  h3 {
    font-size: var(--font-size-h4);
    line-height: var(--line-height-h4);
  }

  .activity {
    width: ${pxToVw(140)};
    flex-direction: column;
    align-items: center;
    gap: ${pxToVw(8)};
    padding: 5px;
    text-align: center;
  }

  &.small {
    gap: 10px;
    justify-content: center;

    .activity {
      width: ${pxToVw(40)};

      .activity-type-name {
        display: none;
      }

      .activity-type-icon {
        width: 25px !important;
        height: 25px !important;

        .free-tag {
          display: none;
        }
        svg {
          transform: scale(0.8) !important;
        }
      }
    }
  }

  @media only screen and (max-width: ${MediaQueryBreakpoints.md}) {
    gap: 20px;
  }
`;

export const StyledThemeActivitiesColumn = styled(StyledThemeActivities)`
  flex-direction: column;

  .activity {
    flex-direction: row;
    align-items: center;
    gap: ${pxToVw(32)};
    padding: 10px 0 10px 4px;
    border-bottom: 1px solid ${Colors.lighterGray};
    &:first-of-type {
      border-top: 1px solid ${Colors.lighterGray};
    }
  }
`;
